async function importFlickity() {
    const { default: Flickity } = await import(/* webpackChunkName: "flickity" */ 'flickity');
    return Flickity;
}

importFlickity().then((Flickity) => {

    // call to update hidden slide aria attributes
    function setHeroSlide (hiddenSlides) {
        hiddenSlides.forEach((hiddenSlide) => {
            hiddenSlide.setAttribute('tabindex', '-1');
        });
    }

    const previousButton = document.querySelector('.recipe-next-prev.previous');
    const nextButton = document.querySelector('.recipe-next-prev.next');

    // Grey out an arrow when there is nothing further to scroll that way. The
    // homepage recipes are hand-picked, so on wide screens every card may already
    // be visible and both arrows are disabled. Called with `this` = the Flickity
    // instance; progress runs 0 (first card at the left) to 1 (last card at the right).
    function updateButtons(progress) {
        // With `contain`, Flickity gives every slide the same target when all the
        // cards fit, so the distance between the first and last target is the
        // scrollable range (and progress is NaN when that range is 0).
        const first = this.slides[0];
        const last = this.slides[this.slides.length - 1];
        const canScroll = !!first && last.target - first.target > 1;
        if (previousButton) {
            previousButton.disabled = !canScroll || progress <= 0.01;
        }
        if (nextButton) {
            nextButton.disabled = !canScroll || progress >= 0.99;
        }
    }

    // init flickity slider
    const carousel = document.querySelector('.recipes-carousel');
    const recipeCarousel = new Flickity(carousel, {
        // flickity event binding
        // https://flickity.metafizzy.co/events.html#ready
        on: {
            ready: function () {
                let hiddenSlides = document.querySelectorAll(".recipe-cell[aria-hidden='true']");
                setHeroSlide(hiddenSlides);
                updateButtons.call(this, 0);
            },
            scroll: function (progress) {
                updateButtons.call(this, progress);
            }
        },
        accessibility: false,
        adaptiveHeight: true,
        cellAlign: 'left',
        // stop once the last card is fully in view, instead of sliding the cards
        // off into empty space
        contain: true,
        draggable: '>1',
        freeScroll: true,
        pageDots: false,
        prevNextButtons: false,
        setGallerySize: false
    });

    // recipe carousel button event listeners
    if (previousButton) {
        previousButton.addEventListener('click', function () {
            recipeCarousel.previous();
        });
    }
    if (nextButton) {
        nextButton.addEventListener('click', function () {
            recipeCarousel.next();
        });
    }
});
